import React from "react";
import isEmpty from 'ramda/es/isEmpty';
import { createContext } from "../../helpers/createContext";
import { normalize } from "../../helpers/normalize";
import useAuth from "../../routes/login/AuthContext";
import { GetIntegrationsMappings, IIntegrationData, IIntegrationsEntrata } from "../../services/IntegrationApi";

interface IEntrataIntegrationContext {
  integrations: IIntegrationData;
  loadIntegrations: (id: number) => Promise<void>;
}

const [EntrataIntegrationContext, useEntrataIntegrationContext] = createContext<IEntrataIntegrationContext>();

export const EntrataIntegrationProvider: React.FC = (props) => {
  const { getAuthToken } = useAuth();
  const [integrations, setIntegrations] = React.useState<IIntegrationData>({
    importCompleteUnits: false,
    importEnabled: false,
    inviteCompleteUnits: false,
    lastImportRun: [],
    mappings: []
  });

  const loadIntegrations = async (id: number) => {
    const response = await GetIntegrationsMappings(id, await getAuthToken());

    if (response && !isEmpty(response)) {
      setIntegrations({
        importEnabled: response.importEnabled,
        importCompleteUnits: response.importCompleteUnits,
        inviteCompleteUnits: response.inviteCompleteUnits,
        lastImportRun: response.lastImportRun,
        mappings: response.mappings as IIntegrationsEntrata[]
      });
    }

    return;
  };

  const value = React.useMemo(
    () => ({
      loadIntegrations,
      integrations,
    }),
    [normalize(integrations)]
  );

  return <EntrataIntegrationContext.Provider value={value} {...props} />;
};

export { useEntrataIntegrationContext };
